'use client';

import type { OpdsFeed, LibraryConnection } from '@/lib/opds/types';
import { EntryCard } from './EntryCard';

export function AcquisitionFeed({
  feed,
  library,
  feedUrl,
}: {
  feed: OpdsFeed;
  library: LibraryConnection;
  feedUrl?: string;
}) {
  return (
    <div className="book-grid grid grid-cols-3 gap-3 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8">
      {feed.entries.map((entry, i) => (
        <EntryCard
          key={`${entry.id}-${i}`}
          entry={entry}
          library={library}
          feedUrl={feedUrl}
          entryIndex={i}
        />
      ))}
    </div>
  );
}
